<template>
  <div>
    <!-- Fondo oscuro -->
    <div v-show="isVisible" class="overlay"></div>

    <!-- Modal -->
    <md-card v-show="isVisible" class="transaction-modal" @click.stop>
      <!-- Encabezado -->
      <div class="modal-header">
        <img
          src="./../../assets/img/Logotipo LS.png"
          alt="Latino Seguros"
          class="header-logo"
        />
        <!--<img :src="bankLogo" alt="Banco" class="header-logo" />-->
        <button class="close-btnModal" @click="closeModal">✕</button>
      </div>

      <!-- Cuerpo -->
      <div class="modal-content">
     

        <div class="envio-via my-4">
          <!-- WhatsApp (obligatorio) -->
          <div class="form-group mb-2">
            <label for="whatsapp1" class="form-label">
              Enviaremos la liga al WhatsApp del número que nos proporciones:
              <span class="text-danger">*</span>
            </label>
            <input
              id="whatsapp1"
              type="tel"
              class="form-control"
              v-model="whatsapp"
              placeholder="Ej. 5555 5555" 
            />
            <small v-if="errores.whatsapp" class="text-danger">
              {{ errores.whatsapp }}
            </small>
          </div>
          <div class="form-group mb-2">
            <label for="whatsapp2" class="form-label">
              Confirma el número:
              <span class="text-danger">*</span>
            </label>
            <input
              id="whatsapp2"
              type="tel"
              class="form-control"
              v-model="whatsappConfirm"
              placeholder="Vuelve a escribir el número"
            />
            <small v-if="errores.whatsappConfirm" class="text-danger">
              {{ errores.whatsappConfirm }}
            </small>
          </div>

          <!-- Correo (opcional) -->
          <div class="form-group mb-2 mt-3">
            <label for="email1" class="form-label">
              Si así lo deseas, también podemos enviar la liga a un correo
              electrónico:
              <small class="text-muted">(Opcional)</small>
            </label>
            <input
              id="email1"
              type="email"
              class="form-control"
              v-model="email"
              placeholder="ejemplo@correo.com"
            />
            <small v-if="errores.email" class="text-danger">
              {{ errores.email }}
            </small>
          </div>
          <div class="form-group mb-2">
            <label for="email2" class="form-label">
              Confirma el correo:
              <small class="text-muted">(Opcional)</small>
            </label>
            <input
              id="email2"
              type="email"
              class="form-control"
              v-model="emailConfirm"
              placeholder="Vuelve a escribir el correo"
            />
            <small v-if="errores.emailConfirm" class="text-danger">
              {{ errores.emailConfirm }}
            </small>
          </div>
        </div>

        <!-- Línea separadora -->
        <v-divider class="my-3"></v-divider>

        <!-- Opciones para imprimir o enviar -->
        <v-row justify="center">
          <v-col cols="12" class="text-center">
            <v-btn
              class="action-btn email"
              :disabled="!puedeEnviar"
              @click="openContactModal('email')"
            >
              Enviar
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </md-card>
    <!-- Modal de contacto reutilizable -->
    <ModalContacto
      ref="modalContacto"
      :transactionDetails="transactionDetails"
      :inputType="currentInputType"
    />
    <!-- Modal de PDF -->
    <div v-show="isPdfModalVisible" class="pdf-modal overlay">
      <button class="close-btn" @click="closePdfModal">✕</button>
      <iframe :src="pdfUrl" width="100%" height="100%" frameborder="0"></iframe>
    </div>
    <Loading :isLoading="isLoading" />
  </div>
</template>

<script>
import americanExpressLogo from "@/assets/img/american-express.png";
import ModalContacto from "./ModalContacto.vue";
import jsPDF from "jspdf";
import Loading from "../isep/Tools/loading.vue";
import { mapGetters } from "vuex";

export default {
  name: "ModalEstadoTransaccion",
  components: {
    ModalContacto,
    Loading,
  },
  data() {
    return {
      isVisible: false,
      bankLogo: "",
      statusIcon: "",
      statusMessage: "",
      transactionDetails: null,
      showActions: false,
      currentInputType: "whatsapp",
      isLoading: false,
      isPdfModalVisible: false, // Controla la visibilidad del modal de PDF
      pdfUrl: "", // URL del PDF generado

      whatsapp: "",
      whatsappConfirm: "",
      email: "",
      emailConfirm: "",
      errores: {
        whatsapp: null,
        whatsappConfirm: null,
        email: null,
        emailConfirm: null,
      },

      contratante: "",
      ramoDescripcion: "",
      recibo: "",
      contratanteEnmascarado: "",
      importeRecibo: "",
      horaVencimiento: "",
      fechaVencimiento: "",
    };
  },
  computed: {
    currentFormattedDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    puedeEnviar() {
      const tienePhone = this.whatsapp !== "" || this.whatsappConfirm !== "";
      const phoneOk = !tienePhone
        ? false
        : this.whatsapp !== "" &&
          this.whatsappConfirm !== "" &&
          this.whatsapp === this.whatsappConfirm;

      const tieneEmail = this.email !== "" || this.emailConfirm !== "";
      const emailOk = !tieneEmail
        ? true
        : this.email !== "" &&
          this.emailConfirm !== "" &&
          this.email === this.emailConfirm;

      return phoneOk && emailOk;
    },
    ...mapGetters(["getPolizaData"]),
  },
  watch: {
    whatsapp(value) {
      this.errores.whatsapp = null;
      this.errores.whatsappConfirm = null;

      // Si borras el primer campo y el segundo aún tiene algo:
      if (value === "" && this.whatsappConfirm !== "") {
        this.errores.whatsapp = "Primero ingresa el número";
      }
    },
    whatsappConfirm(value) {
      this.errores.whatsappConfirm = null;

      // Si ambos llenos pero no coinciden:
      if (this.whatsapp !== "" && value !== "" && this.whatsapp !== value) {
        this.errores.whatsappConfirm = "Los números no coinciden";
      }
    },
    email(value) {
      this.errores.email = null;
      this.errores.emailConfirm = null;
      if (value.trim() === "" && this.emailConfirm.trim() !== "") {
        this.errores.emailConfirm = "Debes proporcionar un correo";
      }
    },
    emailConfirm(value) {
      this.errores.emailConfirm = null;
      // Si ambos tienen texto pero no coinciden:
      if (
        this.email.trim() !== "" &&
        value.trim() !== "" &&
        this.email !== this.emailConfirm
      ) {
        this.errores.emailConfirm = "Los correos no coinciden";
      }
    },
  },
  methods: {
    openModal({
      bankLogo,
      statusIcon,
      statusMessage,
      transactionDetails = null,
      showActions = false,
    }) {
      this.bankLogo = bankLogo;
      this.statusIcon = statusIcon;
      this.statusMessage = statusMessage;
      this.transactionDetails = transactionDetails;
      this.showActions = showActions;
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
    },
    openContactModal(type) {
      // Limpiar errores previos
      this.errores.whatsapp = null;
      this.errores.whatsappConfirm = null;
      this.errores.email = null;
      this.errores.emailConfirm = null;

      // 1) Validar WhatsApp: ambos campos obligatorios y deben coincidir
      if (!this.whatsapp) {
        this.errores.whatsapp = "Debes proporcionar un número de WhatsApp";
        return;
      }
      if (this.whatsappConfirm === "") {
        this.errores.whatsappConfirm = "Confirma tu número de WhatsApp";
        return;
      }
      if (this.whatsapp !== this.whatsappConfirm) {
        this.errores.whatsappConfirm = "Los números no coinciden";
        return;
      }

      // 2) Validar Email (opcional): si alguno de los dos tiene texto, ambos deben coincidir
      const tieneEmail =
        this.email.trim() !== "" || this.emailConfirm.trim() !== "";
      if (tieneEmail) {
        if (this.email.trim() === "") {
          this.errores.email = "Debes proporcionar un correo";
          return;
        }
        if (this.emailConfirm.trim() === "") {
          this.errores.emailConfirm = "Confirma tu correo";
          return;
        }
        if (this.email !== this.emailConfirm) {
          this.errores.emailConfirm = "Los correos no coinciden";
          return;
        }
      }

      // 3) Si todo OK, procede a enviar
      // this.enviarWhatsapp();
      this.sendWhatsAppEmail()
      // if (tieneEmail) {
      //   this.enviarCorreo();
      // }
    },

    async enviarWhatsapp() {
      this.errores.whatsapp = null;
      this.errores.whatsappConfirm = null;

      // Asegurarnos de que ingresaron y confirmaron el mismo número
      if (!this.whatsapp) {
        this.errores.whatsapp = "Debes proporcionar un número de WhatsApp";
        return;
      }
      if (this.whatsapp !== this.whatsappConfirm) {
        this.errores.whatsappConfirm = "Los números no coinciden";
        return;
      }

      this.isLoading = true;

      // 1) Elegir la fuente de datos
      const { pDatosGenerales, pDatosRecibo, pEndosos } =
        this.getPolizaData || {};
      const source =
        pDatosRecibo && Object.keys(pDatosRecibo).length
          ? pDatosRecibo
          : Array.isArray(pEndosos) && pEndosos.length
          ? pEndosos[0]
          : {};

      // 2) Extraer campos
      //const contratante = source.pContratante || "";
      //const contratante = " " + (source.pContratante || "") ;
      const nombreCompleto = source.pContratante || "";
      this.contratante = "";
      this.contratanteEnmascarado = "";

      if (nombreCompleto.trim()) {
        const partes = nombreCompleto.trim().split(/\s+/);
        const nombre = partes[0];
        const apellido = partes[1] || "";
        const inicialApellido = apellido.charAt(0).toUpperCase();
        this.contratante = `${nombre} ${inicialApellido}.`;

        this.contratanteEnmascarado = partes
          .map((p) => {
            const primeraLetra = p.charAt(0);
            const puntos = ".".repeat(p.length - 1);
            return `${primeraLetra}${puntos}`;
          })
          .join(" ");
      }

      const productoOriginal = (pDatosGenerales?.pProducto || "").trim();
      const tienePrefijoNum = /^\d{2}/.test(productoOriginal);
      this.ramoDescripcion = tienePrefijoNum
        ? productoOriginal.slice(2).trim()
        : productoOriginal;

      this.recibo = source.pRecibo || "";
      //const importeRecibo = source.pImporteRecibo != null ? source.pImporteRecibo.toString() : "";
      this.importeRecibo =
        source.pImporteRecibo != null
          ? `$${Number(source.pImporteRecibo).toLocaleString("es-MX", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}`
          : "";
      //const fechaVencimiento = source.pFechaVencimiento || "";
      const fechaHoy = new Date();
      const fechaFormateada = `${fechaHoy
        .getDate()
        .toString()
        .padStart(2, "0")}/${(fechaHoy.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${fechaHoy.getFullYear()}`;

      this.fechaVencimiento = fechaFormateada;

      const ahora = new Date();
      ahora.setHours(ahora.getHours() + 4);

      /* this.horaVencimiento = ahora.toLocaleTimeString("es-MX", {
        hour12: false,
      });*/
      this.horaVencimiento =
        ahora.toLocaleTimeString("es-MX", {
          hour12: false,
          hour: "2-digit",
          minute: "2-digit",
        }) + " Hrs";

      const checkoutSessionId =
        "on-demand?checkoutSession=" +
          localStorage.getItem("checkoutSessionId") || "";

      // 3) Construir payload usando this.whatsapp como destino
      const payload = {
        tipoEnvio: 3,
        entWhats: {
          destination: this.whatsapp.replace(/\D/g, ""), // sólo dígitos
          parameters: [
            this.contratante, // campo 1
            this.ramoDescripcion, // campo 2
            parseInt(pDatosGenerales.pPoliza), // campo 3
            this.contratanteEnmascarado, // campo 4
            this.importeRecibo, // campo 5
            this.horaVencimiento, // campo 6
            this.fechaVencimiento, // campo 7
          ],
          buttonsParameters: [checkoutSessionId],
          template: "llink_pago_latino_2",
          botAttention: false,
          component: { header: {}, buttons: [{ index: 0 }] },
          IdNumeroSalida: null,
        },
      };


      // 4) Envío
      try {
        const response = await this.$store.dispatch("metodoPost", {
          metodo: "ENVIARWHATSAPP",
          data: payload,
        });
        if (response && response.data) {
          this.$swal(
            "Recibo enviado con éxito, gracias por confiar en Latino Seguros",
            "",
            "success"
          );
          this.closeModal();
        } else {
          throw new Error("Respuesta inválida");
        }
      } catch (err) {
        console.error("Error al enviar WhatsApp:", err);
        this.$swal(
          "Error en la consulta",
          "Ocurrió un problema al intentar enviar el mensaje de WhatsApp. Intenta nuevamente.",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    async enviarCorreo() {
      this.isLoading = true;

      // 1) Obtener de Vuex los datos de la póliza
      const { pDatosGenerales, pDatosRecibo, pEndosos } =
        this.getPolizaData || {};

      // 2) Fuente para recibo/endoso
      const sourceRecibo =
        pDatosRecibo && Object.keys(pDatosRecibo).length
          ? pDatosRecibo
          : Array.isArray(pEndosos) && pEndosos.length
          ? pEndosos[0]
          : {};

      // 3) Extraer campos
      const contratante = sourceRecibo.pContratante || "";
      const poliza = pDatosGenerales.pPoliza || "";
      const producto = pDatosGenerales?.pProducto || "";
      const importeRecibo =
        sourceRecibo.pImporteRecibo != null
          ? sourceRecibo.pImporteRecibo.toString()
          : "";
      const fechaVencimiento = sourceRecibo.pFechaVencimiento || "";
      const horaActual = new Date().toLocaleTimeString("es-MX", {
        hour12: false,
      });

      // 4) Recuperar checkoutSessionId
      const tokuUrl = localStorage.getItem("tokuUrl") || "";
      const checkoutSessionIdMail =
        localStorage.getItem("checkoutSessionId") || "";

      // 5) Construir el payload
      const payload = {
        idTemplate: 163,
        sender: "miportal@latinoseguros.com.mx",
        subject: "Pago latino",
        targets: this.email.trim(),
        dinamicContent: `${this.contratante}|${this.ramoDescripcion}|${parseInt(
          pDatosGenerales.pPoliza
        )}|${this.contratanteEnmascarado}|${this.importeRecibo}|${
          this.horaVencimiento
        }|${this.fechaVencimiento}|${checkoutSessionIdMail}`,
        idMessage: 2,
      };

      try {
        const response = await this.$store.dispatch("metodoPost", {
          metodo: "ENVIARCORREO",
          data: payload,
        });

        if (response && response.data) {
          this.$swal(
            "Correo enviado con éxito, gracias por confiar en Latino Seguros.",
            "",
            "success"
          );
          this.closeModal();
        } else {
          throw new Error("Respuesta inválida del servidor");
        }
      } catch (error) {
        console.error("Error al enviar correo:", error);
        this.$swal(
          "Error en la consulta",
          "Ocurrió un problema al intentar enviar el correo. Intenta nuevamente.",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    async sendWhatsAppEmail() {
       this.isLoading = true;
      try {
        const payload = {
          id_checkout_session: this.checkoutSessionId || localStorage.getItem("checkoutSessionId"),
          email: this.email,
          phone: this.whatsapp
        };

        const response = await fetch(
          //" https://latinoseguros.stg.integrations-trytoku.com/domi-v1/liga_inscripcion", //Sandbox
           " https://latinoseguros.integrations-trytoku.com/domi-v1/liga_inscripcion", //Produccion
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
          //    "api-token": "101d4460a543810c4ddc515ef34fe1f6d33d70abc5bc5505cd78b552527b7328"//Sandbox
               "api-token": " b507b695474b35fb9dda0b0dfb59c88e1187d32dadb986a501272ddd3b5cb8d8"//Produccion
            },
            body: JSON.stringify(payload)
          }
        );

        // ❌ error HTTP
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || "Error en la petición");
        }

        // 👇 CLAVE: leer como texto primero
        const text = await response.text();

        // Si viene vacío, todo bien
        if (!text) {
          console.log("Liga de inscripción enviada correctamente (sin body)");
          return { success: true };
        }

        const data = JSON.parse(text);
        this.closeModal()

        this.whatsapp = "",
        this.whatsappConfirm = "",
        this.email = "",
        this.emailConfirm = "",
        this.$swal({
          icon: "success",
          title: "¡Listo!",
          html: `<p style="color:#4b5563; text-align:center; margin:0;">
                  La información se envió correctamente.
                </p>`,
          confirmButtonText: "OK",
          backdrop: 'rgba(0,0,0,0.6)',
          customClass: {
            title: 'swal-title-center',
            confirmButton: 'swal-confirm-btn'
          },
          didOpen: () => {
            const title = document.querySelector('.swal2-title')
            if (title) title.style.color = '#374151'
          }
        })
        console.log("Respuesta liga_inscripcion:", data);
        this.isLoading = false;
        return data;
      } catch (error) {
        this.isLoading = false;
        console.error("Error liga_inscripcion:", error);
        this.$swal({
          icon: "error",
          title: "Error en el envío",
          html: `<p style="color:#4b5563; text-align:center; margin:0;">
                  No fue posible enviar la información. Intenta nuevamente más tarde.
                </p>`,
          confirmButtonText: "OK",
          backdrop: 'rgba(0,0,0,0.6)',
          customClass: {
            title: 'swal-title-center',
            confirmButton: 'swal-confirm-btn'
          },
          didOpen: () => {
            const title = document.querySelector('.swal2-title')
            if (title) title.style.color = '#374151'
          }
        })
        if (this.$swal) {
          this.$swal(
            "Error",
            error.message || "No se pudo generar la liga de inscripción",
            "error"
          );
        }

        throw error;
      }
    },


    closePdfModal() {
      this.isPdfModalVisible = false;
      this.pdfUrl = "";
    },

    async generateAndShowPdf() {
      this.isLoading = true;
      let Autorizada;
      if (this.transactionDetails.autorizacion === "RECHAZADA") {
        Autorizada = false;
      } else {
        Autorizada = true;
      }
      try {
        // Crear el payload con los datos necesarios
        const payload = {
          fecha: this.currentFormattedDate, // Fecha actual
          referencia: this.transactionDetails.referencia,
          autorizacion: this.transactionDetails.autorizacion,
          tarjeta: this.transactionDetails.tarjeta,
          monto: this.transactionDetails.monto,
          plazo: this.transactionDetails.plazo,
          Autorizada: Autorizada,
        };

        // Realizar la consulta al endpoint
        const response = await this.$store.dispatch("metodoPost", {
          metodo: "PDFRECIBOPAGARMOTOR",
          data: payload,
        });

        if (response && response.data) {
          const base64Pdf = response.data.data; // Base64 del PDF recibido
          this.pdfUrl = `data:application/pdf;base64,${base64Pdf}`; // Generar URL para mostrar el PDF
          this.isPdfModalVisible = true; // Mostrar el modal
          this.isLoading = false;
        } else {
          console.error("Error en la respuesta del endpoint", response);
          this.$swal(
            "Error",
            "No se pudo generar el recibo. Intenta nuevamente.",
            "error"
          );
        }
      } catch (error) {
        console.error("Error al consultar PDFRECIBOPAGARMOTOR:", error);
        this.$swal(
          "Error",
          "Ocurrió un problema al intentar generar el recibo. Intenta nuevamente.",
          "error"
        );
      }
    },
  },
};
</script>

<style scoped>
.envio-via .form-group label {
  display: block;
  margin-bottom: 0.25rem; /* deja minimal espacio debajo del label */
}

.envio-via .form-group input.form-control {
  margin-bottom: 0.25rem; /* un pequeño espacio antes del <small> de error (si lo hay) */
}

/* Si deseas que el espacio entre cada “form-group” sea aún menor, puedes anular parte de mb-2 así: */
.envio-via .form-group {
  margin-bottom: 0.95rem; /* en lugar de los ~0.75rem que da mb-2 */
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

.modal-content {
  border: none;
}

.transaction-modal {
  max-width: 500px;
  /*min-width: 350px;*/
  margin: 20px auto;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1010;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.header-logo {
  max-height: 80px;
}

.status-icon {
  width: 60px;
  height: 60px;
  margin: 5px auto;
}

.text-blue {
  color: #003366;
}
.text-left {
  text-align: left;
  margin: 0;
  line-height: 1.5;
}

.action-btn {
  font-weight: bold;
}

.action-btn.whatsapp {
  background-color: #25d366;
  color: white;
}

.action-btn.email {
  background-color: #007bff;
  color: white;
  max-width: none !important;
  min-width: auto !important;
}

.action-btn.print {
  background-color: #003366;
  color: white;
}
/* Estilo para el modal de PDF */
.pdf-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.pdf-modal iframe {
  width: 80%;
  height: 80%;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
}

/* Botón de cierre */
.close-btnModal {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  color: #000;
}

.close-btnModal:hover {
  color: #ff0000;
}

@media (max-width: 576px) {
  .transaction-modal {
    width: 95vw;
    max-width: none;
    left: 50%;
    transform: translateX(-50%);
    top: 5vh;
    max-height: 90vh;
    padding: 12px 10px;
    overflow-y: auto;
  }

  /* Ajustar general del tamaño de texto dentro de la card */
  .transaction-modal {
    /* Por ejemplo, reducir todo el texto un 10%: */
    font-size: 0.9rem;
    /* Si lo deseas aún más pequeño, prueba 0.85rem o 0.8rem */
  }

  /* Ajustar encabezado (h4) */
  .transaction-modal h4 {
    font-size: 1rem; /* Antes era ~1.1rem, ahora más pequeño */
    margin-bottom: 0.4rem;
  }

  /* Ajustar párrafos y labels */
  .transaction-modal p,
  .transaction-modal label {
    font-size: 0.85rem;
    line-height: 1.3;
  }

  /* Ajustar placeholders y texto de inputs (opcional) */
  .transaction-modal input.form-control::placeholder {
    font-size: 0.8rem;
  }
  .transaction-modal input.form-control {
    font-size: 0.85rem;
  }

  /* Ajustar el botón “Enviar” */
  .transaction-modal .action-btn.email {
    font-size: 0.9rem; /* Texto un poco más pequeño */
    padding: 0.4rem 1rem; /* Ajustar padding si quisieras que sea más compacto */
  }

  /* Si deseas un margen interno menor entre los campos, por ejemplo: */
  .envio-via .form-group {
    margin-bottom: 0.75rem;
  }
}
</style>
